module.exports = __webpack_public_path__ + "img/13-oneImg.e49d2d91.png";